/*** IMPORTS FROM imports-loader ***/
(function() {

"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var util_1 = require("~/js/lib/util/util");
var SCRIPT = {
    HIIDO_INTERNAL: '//hdjs.hiido.com/hiido_internal.js',
    WEBSDK: '//cdn.hiido.com/sdk/websdk.js'
};
function addScript(src) {
    return new Promise(function (next) {
        var script = document.createElement('script');
        var headEl = document.getElementsByTagName('head')[0];
        if (script.readyState) {
            script.onreadystatechange = function () {
                if (script.readyState === 'loaded' || script.readyState === 'complete') {
                    script.onreadystatechange = null;
                    next();
                }
            };
        }
        else {
            script.onload = function () {
                script.onload = null;
                next();
            };
        }
        script.src = src;
        headEl.appendChild(script);
    });
}
var Stat = (function () {
    function Stat(op) {
        var _this = this;
        this.prodid = op.prodid || 'yylive';
        this.uid = util_1.cookies.get('yyuid') || '';
        this.param = op.param;
        this.holds = [];
        this.metricsHolds = [];
        if (window.hiidoEvent && window.Metrics) {
            this.isReady = true;
        }
        else {
            this.fetchScript().then(function () {
                _this.runQueue();
            })["catch"](function () { return undefined; });
        }
    }
    Stat.prototype.fetchScript = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, addScript(SCRIPT.HIIDO_INTERNAL)];
                    case 1:
                        _a.sent();
                        return [4, addScript(SCRIPT.WEBSDK)];
                    case 2:
                        _a.sent();
                        this.isReady = true;
                        return [2];
                }
            });
        });
    };
    Stat.prototype.runQueue = function () {
        var _this = this;
        this.holds.forEach(function (param) {
            _this.emit(param);
        });
        this.holds = [];
        this.metricsHolds.forEach(function (_a) {
            var type = _a[0], param = _a[1];
            _this.metrics(type, param);
        });
    };
    Stat.prototype.emit = function (param) {
        var _a = this, isReady = _a.isReady, uid = _a.uid, prodid = _a.prodid;
        if (!isReady) {
            return this.holds.push(param);
        }
        var iParam = Object.assign({}, this.param, param);
        var from = util_1.getParameterByName('f') || '';
        var ref = encodeURIComponent(window.document.referrer) || '';
        var hiidoEvent = window.hiidoEvent;
        if (hiidoEvent) {
            var iHiido = new hiidoEvent(prodid, "" + iParam.eventid);
            iHiido.setActtype(iParam.act_type);
            iHiido.setFrom(from);
            iHiido.setMoreinfo(iParam.more_info);
            iHiido.setRef(ref);
            iHiido.setSid(iParam.sid);
            iHiido.setSys(iParam.sys);
            iHiido.setUid(uid);
            switch (iParam.report_type) {
                case 0:
                    iHiido.reportJudge();
                    break;
                case 1:
                    iHiido.reportProcess();
                    break;
                case 2:
                    iHiido.reportAmount();
                    break;
                case 3:
                    iHiido.reportHeart();
                    break;
                default:
                    break;
            }
        }
    };
    Stat.prototype.metrics = function (type, param) {
        var isReady = this.isReady;
        var Metrics = window.Metrics;
        if (!isReady || !Metrics) {
            return this.metricsHolds.push([type, param]);
        }
        switch (type) {
            case 'service':
                Metrics.serviceReport(param);
                break;
            case 'custom':
                Metrics.customReport(param);
                break;
            default:
                break;
        }
    };
    return Stat;
}());
exports.Stat = Stat;

}.call(window));